import { BasicEntity } from '../types';
import {
  ADD_ENTITY,
  DELETE_ENTITY,
  EDIT_ENTITY,
  EntitiesActions,
  EntitiesState,
  GET_ENTITY,
  LOADING_ENTITY,
  NOTIFY_MESSAGE_ENTITY,
  REFRESH_ENTITY
} from './types';

const DefaultEntityState = {
  list: [],
  selected: [],
  singleSelected: null,
  loading: false,
  notificationMessage: ''
};

const initialState: EntitiesState = {
  user: DefaultEntityState,
  userType: DefaultEntityState,
  studies: DefaultEntityState,
  myStudies: DefaultEntityState,
  otherStudies: DefaultEntityState,
  studiesInProgress: DefaultEntityState,
  studiesCompleted: DefaultEntityState,
  userOccupation: DefaultEntityState
};

const entitiesReducer = (state = initialState, action: EntitiesActions): EntitiesState => {
  switch (action.type) {
    case GET_ENTITY:
      return {
        ...state,
        [action.entityName]: { ...state[action.entityName], list: action.payload }
      };

    case DELETE_ENTITY:
      return {
        ...state,
        [action.entityName]: {
          ...state[action.entityName],
          list: (state[action.entityName].list as BasicEntity[]).filter(
            (entity) => !action.payload.includes(entity._id)
          )
        }
      };

    case EDIT_ENTITY:
      return {
        ...state,
        [action.entityName]: {
          ...state[action.entityName],
          list: (state[action.entityName].list as BasicEntity[]).map((e) =>
            e._id === action.payload._id ? action.payload : e
          )
        }
      };

    case ADD_ENTITY:
      return {
        ...state,
        [action.entityName]: {
          ...state[action.entityName],
          list: [
            ...action.payload,
            ...(state[action.entityName].list as BasicEntity[]).filter(
              (e) => !action.payload.some((p) => p._id === e._id)
            )
          ]
        }
      };

    case LOADING_ENTITY:
      return {
        ...state,
        [action.entityName]: { ...state[action.entityName], loading: action.payload }
      };

    case NOTIFY_MESSAGE_ENTITY:
      return {
        ...state,
        [action.entityName]: { ...state[action.entityName], notificationMessage: action.payload }
      };

    case REFRESH_ENTITY:
      return {
        ...state,
        [action.entityName]: {
          ...state[action.entityName],
          list: [...state[action.entityName].list]
        }
      };

    default:
      return state;
  }
};

export default entitiesReducer;
